/**
 * Sets the current mode that you'd like to use OkHi's services.
 */
export const OkHiMode: { SANDBOX: string; PROD: string } = Object.freeze({
  SANDBOX: 'sandbox',
  PROD: 'prod',
});
